"use client"
/* */
import { TableCell } from './TableCell.mjs';

class TableRow {
  tableBody;
  cells;
  componentProps;
  constructor(tableBody, shape = {}) {
    const { cells = [], ...rest } = shape;
    this.tableBody = tableBody;
    this.cells = cells.map((cellShape) => new TableCell(this, cellShape));
    this.componentProps = rest;
  }
}

export { TableRow };
//# sourceMappingURL=TableRow.mjs.map
